import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import { getUploadUrlRequest } from 'APP/wsApi/wsAppApi/requests/uploadRequests';

import { IGetUploadUrlRequest, IGetUploadUrlResponse } from './uploadModel.types';

export async function getUploadUrl(data: IGetUploadUrlRequest): Promise<IGetUploadUrlResponse> {
  try {
    const result = await getUploadUrlRequest({
      filename: data.fileName,
      contentType: data.mimeType,
    });

    return {
      uploadUrl: result.type.value?.uploadUrl || '',
      publicUrl: result.type.value?.publicFilePath || '',
      headers: result.type.value?.uploadHeaders || {},
    };
  } catch (error) {
    logger.get('API').error('upload.getUploadUrl', error);
    throw buildModelError(error);
  }
}
